<template>
  <v-btn
    elevation="2"
    icon
    rounded="0"
    class="ml-3 position-fixed base-editor-btn"
    v-bind="$attrs"
  >
    <v-tooltip location="top">
      <template #activator="{ props: tooltipProps }">
        <v-icon
          :color="iconColor"
          :class="iconClass"
          v-bind="tooltipProps"
        >{{ icon }}</v-icon>
      </template>
      <span>{{ label }}</span>
    </v-tooltip>
  </v-btn>
</template>

<script>
export default {
  name: 'BaseEditorBtn',

  inheritAttrs: false,

  props: {
    label: {
      type: String,
      default: '',
    },
    icon: {
      type: String,
      default: '',
    },
    iconColor: {
      type: String,
      default: '',
    },
    iconClass: {
      type: String,
      default: '',
    },
  },
};
</script>

<style>
/* Above Vue Flow viewport (z-index 4) and workflow subnav (z-index 4) */
.base-editor-btn.v-btn {
  z-index: 5 !important;
}

/* Only when WorkflowView sets --workflow-editor-btn-top on .workflow */
.workflow .base-editor-btn.v-btn {
  top: var(--workflow-editor-btn-top) !important;
}
</style>
